import { ValidatorRules } from '../../../../util/validator'
import { PortfolioStepState } from '../portfolio-slice'

export const selfSelectRules: ValidatorRules<PortfolioStepState> = {
  asset_weights: [
    (state: PortfolioStepState) => ({
      isValid: state.selfSelect.totalWeights === 1,
      message: 'Asset weights must sum to 100%'
    })
  ],
  emptyUnits: (state: PortfolioStepState) => {
    const units = state.selfSelect.transferUnits.map(x => x.units)
    return {
      isValid: !state.isTransfer || !(units.includes(null) || units.includes(0)),
      message: 'Each asset must be assigned non-zero units'
    }
  },
  emptyAssetWeight: (state: PortfolioStepState) => {
    const weights = state.selfSelect.portfolio.targetWeights.map(x => x.weight)
    return {
      isValid: !(weights.includes(null) || weights.includes(0)),
      message: 'Each asset must be assigned a weight'
    }
  }
}
